import * as THREE from 'three'

const workingColor = new THREE.Color()
const srgbColor = new THREE.Color()
const COLOR_ENDPOINT_EPSILON = 1e-12

function snapColorEndpoint(value: number): number {
  if (Math.abs(value) < COLOR_ENDPOINT_EPSILON) return 0
  if (Math.abs(value - 1) < COLOR_ENDPOINT_EPSILON) return 1
  return value
}

/**
 * 将 Three.js 颜色转换为点云 Raw Shader 使用的 sRGB 编码分量。
 *
 * 点云渲染链会绕过 Three.js 的最终颜色空间转换，因此传给纹理或 uniform 的颜色必须已经是
 * sRGB 编码值。该函数只返回数值分量，不应把结果重新用于受 Three.js 色彩管理的材质颜色。
 *
 * @param color - CSS/Hex/Three.js 颜色；Three.js 按工作色彩空间解释后再转为 sRGB
 * @param target - 可复用的 RGB 数组，避免渲染热路径分配
 * @returns sRGB 编码的 RGB 分量，范围通常为 0~1
 */
export function toPointCloudSRGB(
  color: THREE.ColorRepresentation,
  target: [number, number, number] = [0, 0, 0]
): [number, number, number] {
  workingColor.set(color)
  workingColor.getRGB(srgbColor, THREE.SRGBColorSpace)
  // Three.js 的传递函数近似会把 1 转成 0.9999999999999999；若后续量化时向下取整，
  // 纯色会错误地从 255 变成 254，因此在端点处消除浮点噪声。
  target[0] = snapColorEndpoint(srgbColor.r)
  target[1] = snapColorEndpoint(srgbColor.g)
  target[2] = snapColorEndpoint(srgbColor.b)
  return target
}
